// TODO: Applicare FUNA
/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
 * @restrict E
 * @description Componente per la ricerca delle pratiche di pratiche di Credito Assicurativo
 */
(function() {
  'use strict';
  var CreasRicercaPraticheCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    userSrvc,
    messaggiFctr
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    /* Spinner */
    this.spinner = {
      listaPratiche: false
    };

    /* Filtri di ricerca */
    this.statiPratica = [
	    {key: '', description: 'Tutti'},
	    {key: 'INCORSO', description: 'In corso'},
	    {key: 'VALUTAZIONE', description: 'Valutazione'},
	    {key: 'INTEGRAZIONE', description: 'Integrazione'},
	    {key: 'DEFINITA', description: 'Definita'},
	    {key: 'CONSOLIDATA', description: 'Consolidata'},
	    {key: 'AFFIDATA', description: 'Affidata'},
	    {key: 'GESTIONEPOLIZZE', description: 'Gestione polizze'},
	    {key: 'CONCLUSA', description: 'Conclusa'},
	    {key: 'ANNULLATA', description: 'Annullata'},
	    {key: 'RIFIUTATA', description: 'Rifiutata'},
      {key: 'LAVORAZIONE', description: 'In lavorazione'}
	  ];
    
    this.intestazioneSocieta = '';
    this.statoPratica = this.statiPratica[0];
    this.dataAperturaDa = null;
    this.dataAperturaA = new Date();

    /* Flag che visualizza il messaggio di nessun record trovato */
    this.noResultsFlag = false;

    /* Tabella Pratiche */
    this.praticheTableData = null;
    this.praticheTableLabel = [
      {
        name: 'ID Pratica',
        field: 'idPratica',
        minWidth: 130,
        enableFiltering: true
      },
      {
        name: 'Intestazione',
        field: 'intestatario.intestazione',
        minWidth: 200,
        enableFiltering: true
      },
      {
        name: 'Presa in carico',
        field: 'dataPresaInCarico',
        minWidth: 130,
        enableFiltering: true
      },
      {name: 'Stato', field: 'stato', minWidth: 130, enableFiltering: true}
    ];

    var self = this;

    this.init = function () {
      this.initCampiRicerca();
    };

     /**
	 * @ngdoc method
	 * @name initCampiRicerca
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
	 * @description Inizializza i campi di ricerca in base all'eventuale valorizzazione dei query params della rotta
	 */
    this.initCampiRicerca = function () {
      if (this.$stateParams.intestazione && this.$stateParams.intestazione !== '') {
        this.intestazioneSocieta = this.$stateParams.intestazione;
      }
      if (this.$stateParams.stato && this.$stateParams.stato !== '') {
        for (var i in this.statiPratica) {
          var stato = this.statiPratica[i];
          if (stato.key === this.$stateParams.stato) {
            this.statoPratica = stato;
          }
        }        
      }
      if (this.$stateParams.dataDa) {
        this.dataAperturaDa = new Date(this.$stateParams.dataDa);
      }
      if (this.$stateParams.dataA) {
        this.dataAperturaA = new Date(this.$stateParams.dataA);
      }
      if (this.$stateParams.intestazione || this.$stateParams.stato || this.$stateParams.dataDa || this.$stateParams.dataA) {
        this.searchPratiche();
      }
    }

    /**
	 * @ngdoc method
	 * @name isSearchDisabled
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
	 * @description Verifica se è possibile eseguire la ricerca in base ai filtri inseriti
	 * @return {boolean} - 'false' se la ricerca è avviabile, 'true' se è necessario modificare o inserire dati
	 */
    this.isSearchDisabled = function() {
      if (!self.intestazioneSocieta && self.statoPratica && self.statoPratica.key !== '') {
        return false;
      }

      if (!self.statoPratica) {
        return true;
      }
      
      if (self.statoPratica.key === '' && self.intestazioneSocieta.trim().length < 2) {
    	return true;
      }

      if (self.intestazioneSocieta && self.intestazioneSocieta.trim() !== '') {
        return false;
      }

      if (self.statoPratica && self.intestazioneSocieta.trim() !== '') {
        return false;
      }

      return true;
    };

    /**
		 * @ngdoc method
		 * @name promiseRicercaPratiche
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Esegue la chiamata per ottenere i risultati delle pratiche di Credito Assicurativo
		 * @return {Promise} - Restituisce una promise contenente la ricerca delle pratiche di Credito Assicurativo
		 */
    this.promiseRicercaPratiche = function() {
      var queryParamsObj = {};
      if (self.intestazioneSocieta) {
        queryParamsObj['ragioneSociale'] = self.intestazioneSocieta;
      }
      if (self.statoPratica && self.statoPratica.key) {
        queryParamsObj['statoPratica'] = self.statoPratica.key;
      }
      if (self.dataAperturaDa) {
        queryParamsObj['dataDa'] = new Date(self.dataAperturaDa).toISOString();
      }
      if (self.dataAperturaA) {
        queryParamsObj['dataA'] = new Date(self.dataAperturaA).toISOString();
      }

      var queryParams = $httpParamSerializer(queryParamsObj);
      var queryString = '';
      if (queryParams !== '') {
        queryString = '?' + queryParams;
      }

      return this.$http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.RICERCA + queryString
      });
    };

    /**
		 * @ngdoc method
		 * @name searchPratiche
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
		 * @description Avvia la ricerca delle pratiche in base ai filtri inseriti e popola la tabella
		 */
    this.searchPratiche = function() {
      if (self.isSearchDisabled() !== false) {
        return;
      }

      self.noResultsFlag = false;
      self.spinner.listaPratiche = true;

      $q
        .all({
          ricercaPratiche: self.promiseRicercaPratiche()
        })
        .then(
          function(response) {
            if (
              self.messaggiFctr.processaResponse(response.ricercaPratiche) !==
              false
            ) {
              self.noResultsFlag = false;
              self.praticheTableData = null;
              return;
            }

            self.noResultsFlag = (response.ricercaPratiche.data.result.length === 0);
            self.praticheTableData = response.ricercaPratiche.data.result;
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.ricercaPratiche);
            self.praticheTableData = null;
          }
        )
        .finally(function() {
          self.spinner.listaPratiche = false;
        });
    };

    /**
		 * @ngdoc method
		 * @name openPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
		 * @description Apre la scheda della pratica selezionata
		 * @param {Object} tableRow - Oggetto contenente i dati della pratica selezionata
		 */
    this.openPratica = function(tableRow) {
      self.$state.go('creas-dettaglio-pratica', {
    	  ndg:tableRow.intestatario.ndg,
    	  idPratica: tableRow.idPratica
      });
    };

    /**
		 * @ngdoc method
		 * @name createNewPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaPratiche
		 * @description Apre la funzione di ricerca cliente per iniziare la procedura di creazione di una nuova pratica di credito assicurativo
		 */
    this.createNewPratica = function() {
      self.$state.go('creas-ricerca-cliente');
    };

    this.userSrvc.abilitazioniPronte.then(function(result) {
      // Verifico se Credito assicurativo è abilitato
      // in caso contrario rimando alla home
      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
        if (
          self.userSrvc.abilitazioni[i].codice ===
          'CreditoAssicurativoPMIAbilitato'
        ) {
          self.init();
          return;
        }
      }

      self.$state.go('schedaCliente');
    });
  };

  CreasRicercaPraticheCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'UserSrvc',
    'CreasMessaggiFctr'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasRicercaPratiche/creasRicercaPratiche.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasRicercaPraticheComponent = {
    controller: CreasRicercaPraticheCtrl,
    controllerAs: 'creasRicercaPraticheCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasRicercaPratiche', CreasRicercaPraticheComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasRicercaPratiche/creasRicercaPratiche.cmpt.js
// module id = 14
// module chunks = 0 1